/**
 * API Service - Axios configuration and API calls
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token invalid, redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Health Status API
export const healthAPI = {
  getProjectHealth: (projectId) =>
    api.get(`/health/projects/${projectId}`),

  updateProjectHealth: (projectId, data) =>
    api.put(`/health/projects/${projectId}`, data),

  getHealthSummary: () =>
    api.get('/health/summary'),

  getHealthDashboard: () =>
    api.get('/health/dashboard'),

  getProjectHealthHistory: (projectId, days = 30) =>
    api.get(`/health/projects/${projectId}/history`, { params: { days } }),

  createHealthSnapshot: (projectId) =>
    api.post(`/health/projects/${projectId}/snapshot`),
};

// Task Aging API
export const agingAPI = {
  getConfig: () =>
    api.get('/exports/aging/config'),

  updateConfig: (config) =>
    api.put('/exports/aging/config', config),

  getAgedTasks: (filters = {}) =>
    api.get('/exports/aging/tasks', { params: filters }),

  getAgingSummary: (projectId = null) =>
    api.get('/exports/aging/summary', { params: { project_id: projectId } }),

  getAgingAlerts: () =>
    api.get('/exports/aging/alerts'),
};

// Export API
export const exportAPI = {
  generateReport: (reportType, format, filters = {}) =>
    api.post('/exports/generate', {
      report_type: reportType,
      format: format,
      ...filters
    }, {
      responseType: 'blob'
    }),
};

export default api;
